var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    width: 42.544,
    height: 51.524,
    viewBox: "0 0 42.544 51.524",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28157",
    transform: "translate(-199.343 -70.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20797",
    d: "M214.644 90.556a9.908 9.908 0 1 1 9.909-9.907 9.918 9.918 0 0 1-9.909 9.907zm0-18.494a8.585 8.585 0 1 0 8.586 8.586 8.6 8.6 0 0 0-8.586-8.586z",
    className: "cls-1",
    transform: "translate(5.97 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20798",
    d: "M211.739 94.5a.663.663 0 0 1-.657-.582l-1.458-12.043a.662.662 0 0 1 1.314-.16l1.462 12.04a.66.66 0 0 1-.577.737.484.484 0 0 1-.084.008z",
    className: "cls-1",
    transform: "translate(11.925 12.677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20799",
    d: "M208.191 94.5a.675.675 0 0 1-.657-.741l1.458-12.043a.662.662 0 0 1 1.314.16l-1.458 12.043a.663.663 0 0 1-.657.581z",
    className: "cls-1",
    transform: "translate(9.375 12.677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20800",
    d: "M239.649 110.014h-38.068a1.741 1.741 0 0 1-1.738-1.738v-20.09a5.448 5.448 0 0 1 3.459-5.048L211.4 80a.664.664 0 0 1 .852.368L219.793 99a.887.887 0 0 0 1.645 0l7.543-18.631a.664.664 0 0 1 .852-.368l8.1 3.134a5.448 5.448 0 0 1 3.459 5.048v20.09a1.741 1.741 0 0 1-1.743 1.741zm-28.38-28.54l-7.49 2.9a4.116 4.116 0 0 0-2.613 3.814v20.09a.416.416 0 0 0 .415.415h38.068a.416.416 0 0 0 .415-.415V88.186a4.115 4.115 0 0 0-2.615-3.814l-7.488-2.9-7.3 18.027a2.209 2.209 0 0 1-4.1 0z",
    className: "cls-1",
    transform: "translate(0 11.249)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20801",
    d: "M203.778 102.322a.663.663 0 0 1-.661-.662V86.928a.663.663 0 0 1 1.325 0v14.733a.664.664 0 0 1-.664.661z",
    className: "cls-1",
    transform: "translate(3.993 18.941)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20802",
    d: "M215.349 102.322a.662.662 0 0 1-.661-.662V86.928a.661.661 0 1 1 1.323 0v14.733a.662.662 0 0 1-.662.661z",
    className: "cls-1",
    transform: "translate(18.109 18.941)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalIcon);
export default __webpack_public_path__ + "static/media/personal-icon.f3f93ec0.svg";
export { ForwardRef as ReactComponent };